var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M20.796 18.293c.147.287.214.593.203.918-.012.326-.1.623-.264.893a1.884 1.884 0 0 1-1.6.896H4.87a1.884 1.884 0 0 1-1.6-.896 1.847 1.847 0 0 1-.269-.893 1.925 1.925 0 0 1 .18-.918l7.132-14.247A1.894 1.894 0 0 1 12.003 3a1.843 1.843 0 0 1 1.67 1.046l7.123 14.247zM10.877 7.878v6.372h2.251V7.878h-2.251zm.062 10.81c.293.293.647.44 1.064.44.416 0 .77-.147 1.064-.44.293-.292.44-.647.44-1.063 0-.416-.147-.77-.44-1.063a1.45 1.45 0 0 0-1.064-.44c-.417 0-.771.147-1.064.44-.294.292-.44.647-.44 1.063 0 .416.146.77.44 1.063z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning_red.b5e7b40093dff7a736ccfd801f5afdf9.svg";
export { ForwardRef as ReactComponent };